// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-CellBom3MaterialSelect-CellBom3MaterialSelect-module__button--x_CGT {
  width: 100%;
  padding: 4px 12px;
}
.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-CellBom3MaterialSelect-CellBom3MaterialSelect-module__buttonContent--JtCZj {
  display: flex;
  gap: 6px;
  align-items: center;
}
.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-CellBom3MaterialSelect-CellBom3MaterialSelect-module__rightIcon--nOPUt {
  color: #e43d00;
}
.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-CellBom3MaterialSelect-CellBom3MaterialSelect-module__materialLabel--QfpH5 {
  flex: 1;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-CellBom3MaterialSelect-CellBom3MaterialSelect-module__materialLabel--QfpH5:hover {
  text-decoration-line: underline;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom3/Bom3Positions/cellComponents/CellBom3MaterialSelect/CellBom3MaterialSelect.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;AACF;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAAF;AAEA;EACE,cAAA;AAAF;AAEA;EACE,OAAA;EACA,gBAAA;EAEA,uBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,4BAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCAAA;AAFF;AAGE;EACE,+BAAA;AADJ","sourcesContent":[".button {\n  width: 100%;\n  padding: 4px 12px;\n}\n\n.buttonContent {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n.rightIcon {\n  color: #e43d00;\n}\n.materialLabel {\n  flex: 1;\n  text-align: left;\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  &:hover {\n    text-decoration-line: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `src-businessServices-services-bsBom3-Bom3Positions-cellComponents-CellBom3MaterialSelect-CellBom3MaterialSelect-module__button--x_CGT`,
	"buttonContent": `src-businessServices-services-bsBom3-Bom3Positions-cellComponents-CellBom3MaterialSelect-CellBom3MaterialSelect-module__buttonContent--JtCZj`,
	"rightIcon": `src-businessServices-services-bsBom3-Bom3Positions-cellComponents-CellBom3MaterialSelect-CellBom3MaterialSelect-module__rightIcon--nOPUt`,
	"materialLabel": `src-businessServices-services-bsBom3-Bom3Positions-cellComponents-CellBom3MaterialSelect-CellBom3MaterialSelect-module__materialLabel--QfpH5`
};
export default ___CSS_LOADER_EXPORT___;
